import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import LoadingButton from '@/components/ui/LoadingButton/LoadingButton.tsx';
import { useTranslation } from 'react-i18next';
import useFaqDelete from '@/api/useFaqDelete.ts';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import DeleteIcon from '@mui/icons-material/Delete';

type DeleteFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  selectedElement: number | null | undefined;
};

function DeleteFaqModal({ isOpen, onClose, onConfirm, selectedElement }: DeleteFaqModalProps) {
  const { t } = useTranslation();
  const {
    mutateAsync: deleteFaq,
    isError: isErrorDeleteFaq,
    isPending: isLoadingDeleteFaq,
    isSuccess: isSuccessDeleteFaq,
    error: errorDeleteFaq,
  } = useFaqDelete();

  const handleDeleteFaq = async () => {
    if (!selectedElement) return;
    try {
      await deleteFaq({ ids: [selectedElement] });
      if (onConfirm) {
        onConfirm();
      }
      onClose();
    } catch (error) {
      console.error('Error deleting faq: ', error);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('modals.deleteFaq.title')}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-2 empty:hidden mb-2">
          {isSuccessDeleteFaq && <Alert severity="success">{t('modals.deleteFaq.successMessage')}</Alert>}
          {isErrorDeleteFaq && <Alert severity="error">{errorDeleteFaq?.message as string}</Alert>}
        </div>
        <DialogContentText>{t('modals.deleteFaq.info')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-wrap grow p-4 pt-0 justify-between">
          <BackButton onClick={onClose} autoFocus />
          <LoadingButton
            startIcon={<DeleteIcon />}
            loading={isLoadingDeleteFaq}
            color="error"
            variant="contained"
            onClick={handleDeleteFaq}
          >
            {t('button.delete')}
          </LoadingButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteFaqModal;
